/**
 * @description Renders the header of the FAQ Page
 */

import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const styles = {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  }
}

/**
 * FAQ page header component
 *
 * @param {object} props
 */
const FaqHeader = (props) => (
  <Box sx={styles.container}>
    <Typography variant='h4'>Frequently Asked Questions</Typography>
    <Typography fontWeight='bold'>{ props.facilityObj.facility }</Typography>
  </Box>
);

FaqHeader.propTypes = {
  facilityObj: PropTypes.object.isRequired
}

export default FaqHeader;
